<template>
  <div>
    <mobile-dialog title="邀请好友" :visible.sync="dialogVisible" @close="close" @confirm="close">
      <template #content>
        <div class="main">
          <div class="way">
            <span>方法一：分享邀请码给好友，预约时输入该邀请码。</span>
            <div class="code"><span>{{ inviteCode }}</span></div>
          </div>
          <div class="way">
            <span>方法二：复制专属链接并分享给好友。</span>
            <div class="box">
              <input class="link" type="text" :value="inviteUrl" readonly />
              <div class="copy-btn" @click="copy(inviteUrl)">复制</div>
            </div>
          </div>
        </div>
      </template>
    </mobile-dialog>
  </div>
</template>

<script>
import MobileDialog from '@/views/mobile/components/dialog/Index.vue'

import { inviteCode } from '@/api/system.api.js'

import { mapMutations } from 'vuex'

export default {
  name: 'PcInvitationDialog',
  components: {
    MobileDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { 
      dialogVisible: false,
      inviteCode: '',
      inviteUrl: '',
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    user() {
      return this.$store.getters.user
    },
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val

      if (val) this.getInviteCode()
    }
  },
  methods: {
    ...mapMutations(['setTipsDialog']),
    close() {
      this.$emit('update:visible', false)
    },
    copy(text) {
      this.$copyText(text)
      this.setTipsDialog({ visible: true, tips: '复制成功' })
      this.close()
    },
    async getInviteCode() {
      // 防止当前阶段还未加载出来时触发
      if (this.stage !== 0 && this.stage !== 1) {
        this.tips = '请刷新页面后重试~'
        this.setTipsDialog({ visible: true, tips: this.tips })
        return false
      }

      const params = {
        token: this.user.token,
        type: this.stage == 0 ? 2 : 3, // 根据阶段类型判断是邀请预约
      }
      await inviteCode(params)
        .then((res) => {
          if (res.code == 0) {
            this.inviteCode = res.data.inviteCode
            this.inviteUrl = res.data.inviteUrl
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  margin-bottom: 4vw;
  height: 50vw;
  font-size: 4vw;
  white-space: pre-wrap;

  .way {
    margin-bottom: 5vw;
  }

  .code {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-size: 3.2vw;
    }
  }

  .box {
    display: flex;
    align-items: center;
    margin-top: 1.333333vw;
  }

  .link {
    flex: 1;
    padding: 0 1.333333vw;
    height: 8vw;
    font-size: 3.2vw;
    background: #fdfcf7;
    border: .133333vw solid #e2d6cb;
    outline: none;
  }

  .copy-btn {
    margin-left: 1.333333vw;
    padding: 0 1.333333vw;
    height: 8vw;
    line-height: 8vw;
    font-size: 3vw;
    color: #fff;
    background: #388176;
    border: .133333vw solid #388176;
  }
}
</style>